import { createContext } from 'react';

import { captureException } from '@sentry/browser';

export interface UseDeleteInfieldLocationConfigMutationContextInterface {
  captureException: typeof captureException;
}

export const defaultValue: UseDeleteInfieldLocationConfigMutationContextInterface =
  {
    captureException,
  };

export const UseDeleteInfieldLocationConfigMutationContext =
  createContext<UseDeleteInfieldLocationConfigMutationContextInterface>(
    defaultValue
  );
